import {useMutation, useQueryClient} from '@tanstack/react-query';
import { toast } from 'sonner';

import AxiosAgent from "@/lib/axios-agent-instance.ts";

type APIPayload = {
  request_id?: string;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const closeAgentChat = async (payload: APIPayload) => {
  try {
    const { request_id } = payload;
    const response = await AxiosAgent.get(`/close-chat-request?chat_request=${request_id}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
          `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useCloseAgentChat = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => closeAgentChat(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['get_all_agent_chat_requests'] });
      console.log(data);
    },
    onError: (error) => {
      toast.error('Closing agent chat failed', { description: error.message });
    },
  });
};
